import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { sortSelections, sortGreyhoundsSelections } from 'src/domains/layouts/utils/sortSelections';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { calculateRaceStatus } from 'src/domains/sportsbook/utils/filterRacesWithFinishState';
import { MarketId } from 'src_common/common/websocket2/id/WebsocketId';
import { sortSelectionsByCriteria } from 'src_common/utils/sport/sort';
import { GreyhoundRacingRow } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummaryRow/GreyhoundRacing/GreyhoundRacingRow';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { HeadersGreyhoundRacing } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/greyhoundRacing/HeadersGreyhoundRacing';
import {
    RaceRowsWrapper,
    RaceSummaryListWrapper,
    RaceSummaryNoHistory,
} from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/greyhoundRacing/RaceSummaryGreyhoundRacing.style';

interface PropsType {
    marketId: MarketId;
    type?: string;
}

export const RaceSummaryGreyhoundRacing = observer('RaceSummaryGreyhoundRacing', (props: PropsType) => {
    const { marketId, type } = props;

    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const marketModel = marketId.getModel();
    if (marketModel === null) {
        return null;
    }

    const eventModel = marketModel.getEvent();
    if (eventModel === null) {
        return null;
    }

    const selections = eventModel.antePost
        ? sortSelections(marketModel.selections.filter((x) => x.display))
        : sortGreyhoundsSelections(marketModel.selections.filter((x) => x.display));

    const selectionWithPriceHistory = (selection: SelectionModel): boolean => selection.priceHistory.length > 0;
    const hidePriceHistoryColumn = selections.find(selectionWithPriceHistory) === undefined;

    const displayOrder =
        marketModel.displayOrderTag === undefined || marketModel.displayOrderTag === '-'
            ? 'by-place'
            : marketModel.displayOrderTag;
    const marketSelections = selections.filter((x) => x.display);
    const itemsForView = sortSelectionsByCriteria(marketSelections, displayOrder);

    const raceStatus = calculateRaceStatus(eventModel.timeSettingsTimeline, eventModel.state);
    const isRaceInProgress = raceStatus === 'RaceStatusInProgress';
    const shouldDisplayTrainer = type === 'cast' ? false : true;

    const inAntePost = eventModel.antePost;

    return (
        <RaceSummaryNoHistory variant={configState.componentVariants.sportsbookVariant}>
            <RaceSummaryListWrapper variant={configState.componentVariants.sportsbookVariant}>
                <HeadersGreyhoundRacing
                    inAntePost={inAntePost}
                    isPriceHistoryHidden={hidePriceHistoryColumn}
                    market={marketModel}
                    type={type}
                />
                <RaceRowsWrapper variant={configState.componentVariants.sportsbookVariant}>
                    {itemsForView.map((selection: SelectionModel) => (
                        <GreyhoundRacingRow
                            key={selection.id}
                            selectionId={selection.id2}
                            type={type}
                            displayTrainer={shouldDisplayTrainer}
                            isRaceInProgress={isRaceInProgress}
                            isPriceHistoryHidden={hidePriceHistoryColumn}
                        />
                    ))}
                </RaceRowsWrapper>
            </RaceSummaryListWrapper>
        </RaceSummaryNoHistory>
    );
});
